<template>

    <!-- Head -->
    <div class="d-lg-flex align-items-lg-center justify-content-lg-between">
        <div>
            <HeaderContent title="Reservation Report"/>
        </div>
        <div class="d-lg-flex align-items-lg-center">
            <BFormInput v-model="dateState" type="date"></BFormInput>
            <span class="align-middle px-3 h-100">-</span>
            <BFormInput v-model="nextDateState" type="date"></BFormInput>
        </div>
    </div>
   
    <ReservationReportStatistics title="Reservation Report Statistics" :data="statistics"/>
    <!-- <ReservationReportDataTable :data="data" :header="headers" :currentPage="currentPage" :custom-actions="customActions"/> -->

   <!-- Filter and table -->
  <BCard class="mt-3">
    <!-- Form  -->
    <BRow>
        <BCol>
            <div class="position-relative mr-4">
                <div class="position-absolute" style="top: 50%;right: 1em; transform: translateY(-50%);">
                    <i class="ios ion-ios-search"></i>
                </div>
                <BFormInput type="text" class="form-control bg-light" placeholder="Search">

                </BFormInput>
            </div>
        </BCol>
        <BCol>
            <BFormSelect v-model="statusBookingState" class="form-control" :options="statusBooking"></BFormSelect>
        </BCol>
        <BCol>
            <BFormSelect class="form-control" v-model="pickedTypeRoom" :options="typeRoom"></BFormSelect>
            
        </BCol>
        <BCol>
            <BFormSelect class="form-control" v-model="roomOfType.def" :options="roomOfType.res.value"></BFormSelect>
            
        </BCol>
        <BCol>
            <BRow align-h="end">
                <BFormSelect class="form-control w-50 bg-light" v-model="stateExport" :options="exportOption"></BFormSelect>
            </BRow>
            
        </BCol>
    </BRow>
            <ReservationReportFilter v-model="staticHeaders" :options="headers.filter(item => item.key==='action'? '':headers)"></ReservationReportFilter>
        <div class="table-responsive bg-white rounded-3 mb-0 mt-4">

        <BTable   :items="data" :fields="headers.filter(item => staticHeaders.includes(item.key))" class=" text-left">
            <template #cell(type_room)="data">
              
                <BBadge class="badge-type-room" :bg-variant="data.item.type_room == 'Deluxe' ? 'danger' : data.item.type_room == 'Super Deluxe' ? 'light' : 
                    data.item.type_room == 'Family' ? 'orange' : data.item.type_room == 'Studio' ? 'success' : data.item.type_room == 'Honeymoon' ? 'primary' : ''">{{ data.item.type_room }}
                </BBadge>
              
            </template>
            <template #cell(action)>
                <BButton v-tooltip="'Print Data'">
                    <i class="fas fa-print"></i>
                </BButton>
            </template>
        </BTable> 
        </div>
        
        <div class="pagination d-lg-flex d-flex align-items-center justify-content-between bg-white rounded-3">
        <div class="d-lg-flex d-flex align-items-center p-4">
            <div class="pagination-option">
                <BFormSelect v-model="perPage" :options="options" class="">
                </BFormSelect> 
            </div>
            <div class="pagination-text">
                <span class="ms-2" style="white-space: nowrap">Showing {{ (currentPage - 1) * perPage + 1 }} to {{ (currentPage * perPage, data.length) }}
                    of {{ data.length }}              
                </span>
            </div>
        </div>
        <div class="w-25 p-4">
            <BPagination
              v-model="currentPage"
              :total-rows="data.length"
              :per-page="perPage"
              aria-controls="my-table"
              class="mb-0 justify-content-end">
            </BPagination>
        </div>
    </div>
    </BCard>


</template>

<script>
import { ref, reactive, watch } from "vue";
import { 
    BFormInput, BButton, BTable, BCard, BRow, BCol, BFormSelect, BBadge, BPagination
} from "bootstrap-vue-next";
import HeaderContent from "@/components/HeaderContent.vue";
import ReservationReportStatistics from "@/components/StatisticData.vue";
// import ReservationReportDataTable from "@/components/DataTable.vue";
import ReservationReportFilter from "./ReservationReportFilter.vue";
import iconReserved from '../../../../public/icons/receipt.svg';
import iconCheckIn from '../../../../public/icons/clipboard-check.svg';
import iconCheckOut from '../../../../public/icons/door-open.svg';

export default {
    components: {
        BFormInput,
        BButton,
        BTable,
        BCard,
        BRow,
        BCol,
        BFormSelect,
        BBadge,
        BPagination,
        HeaderContent,
        ReservationReportStatistics,
        // ReservationReportDataTable,
        ReservationReportFilter
    },
    

   setup(){
    const perPage = ref(10)
const currentPage = ref(1)
const options = ref([
  {
      text: '10',
      value: 10,
  },
  {
      text: '25',
      value: 25,
  },
  {
      text: '50',
      value: 50,
  },
])
        const data = ref([
            {
                guest_name: 'Mr Bones',
                reservation_no: 'DR-01/18/02/2025',
                type_room: 'Deluxe',
                no_room: 'B2',
                price: 750000,
                duration: '2 night',
                amount: 1500000,
                status: 'full payment',
                source: 'Booking.com',
            },
            {
                guest_name: 'Mr Jhon',
                reservation_no: 'DR-01/19/02/2025',
                type_room: 'Super Deluxe',
                no_room: 'A1',
                price: 880000,
                duration: '1 night',
                amount: 880000,
                status: 'full payment',
                source: 'Booking.com',
            },
            {
                guest_name: 'Mr Doe',
                reservation_no: 'DR-01/19/02/2025',
                type_room: 'Honeymoon',
                no_room: 'A3',
                price: 880000,
                duration: '1 night',
                amount: 880000,
                status: 'full payment',
                source: 'Booking.com',
            },
            {
                guest_name: 'Mr Albert',
                reservation_no: 'DR-01/19/02/2025',
                type_room: 'Family',
                no_room: 'C5',
                price: 750000,
                duration: '1 night',
                amount: 750000,
                status: 'down payment',
                source: 'Expedia',
            },
            {
                guest_name: 'Mr Kevin',
                reservation_no: 'DR-01/19/02/2025',
                type_room: 'Studio',
                no_room: 'C5',
                price: 750000,
                duration: '1 night',
                amount: 750000,
                status: 'down payment',
                source: 'Expedia',
            }
        ])

        
        const headers = ref([
            { key: 'guest_name', label: 'Guest Name'},
            { key: 'reservation_no', label: 'Reservation No'},
            { key: 'type_room', label: 'Room Type',thClass:'pl-3'},
            { key: 'no_room', label: 'Room No',class: 'text-center'},
            { key: 'price', label: 'Price(Night)',thClass:'text-center',tdClass:'text-center'},
            { key: 'duration', label: 'Duration',class: 'text-center'},
            { key: 'source', label: 'Source',class: 'text-center'},
            { key: 'amount', label: 'Amount',thClass:'text-center',tdClass:'text-center'},
            { key: 'status', label: 'Payment Status',thClass:'text-center',tdClass:'text-center'},
            { key: 'action', label: 'Action'},
            
        ])
        const staticHeaders = ref(headers.value.map(item => item.key))
        const statusBooking = ref([
        { value: 'select', text: 'Select Status'},
            {value: 'reserve', text: 'Reserve'},
            {value: 'checkIn', text: 'Check In'},
            {value: 'checkOut', text: 'Check Out'},
            {value: 'inHouse', text: 'In House'},
            {value: 'void', text: 'Void'},
        ])

        const typeRoom = ref([
        { value: 'select', text: 'Select Type'},
        
            {
                value: 'deluxe', 
                text: 'Deluxe',
                room : [
                    {value: 'B2', text: 'B2'},
                    {value: 'B4', text: 'B4'},
                    {value: 'A2', text: 'A2'},
                ]
            },
            {
                value: 'family_room', 
                text: 'Family Room',
                room : [
                    {value: 'C3', text: 'C3'},
                    {value: 'C6', text: 'C6'},
                    
                ]
            },   
            {
                value: 'suite_honey_moon', 
                text: 'Suite Honey Moon',
                room : [
                    {value: 'C1', text: 'C1'},
                    {value: 'C2', text: 'C2'},
                ]
            },   
        ])
        const pickedTypeRoom = ref('select')
        const statusBookingState = ref('select')
        const roomOfType = reactive({
           def :  'select',
           res : {value : [{value:'select',text:'Select Room'}]}
        })
        const date = new Date()
        const todayDate = `${date.getFullYear()}-0${date.getMonth()+1}-${date.getDate()}`
        const dateState = ref(todayDate)
        const nextDateState = ref(todayDate)
        const exportOption = [
        {
            value: 'export',
            text: 'export'
            },
        
            {
            value: 'pdf',
            text: 'PDF'
            },
            {
            value: 'excel',
            text: 'Excel'
            }
        ]
        const stateExport = ref('export')
      
        watch(pickedTypeRoom,(newRoomType,oldRoomType)=>{
            
            newRoomType !== 'select' || newRoomType !== oldRoomType ?  

                typeRoom.value.map(tr=>{tr.value == newRoomType ? roomOfType.res.value =  [{value:'select',text:"Select Room"}].concat(tr.room) 
                : null}) 
                : roomOfType.res =  [{value:'select',text:"asd"}]
        })

        const statistics = [
            {key : 'Reserve', label : 'Total', value : 80, color: 'primary', icon: iconReserved},
            {key : 'Check-in', label : 'Total', value : 100, color: 'success', icon: iconCheckIn},
            {key : 'Check-out', label : 'Total', value : 90, color: 'warning', icon: iconCheckOut},
        ]
            
        return {
            data,
            headers,
            statusBooking,
            typeRoom,
            pickedTypeRoom,
            roomOfType,
            statusBookingState,
            dateState,
            date,
            nextDateState,
            exportOption,
            stateExport,
            staticHeaders,
            statistics,
            perPage,
            currentPage,
            options
            
        }
    }

}
</script>

<style>

</style>